import React, { InputHTMLAttributes, type JSX } from 'react';
import { Control, useController } from 'react-hook-form';

type IRadio = InputHTMLAttributes<HTMLInputElement> & {
  required: boolean;
  id: string;
  defaultChecked?: boolean;
  value?: string;
} & (
    | {
        name?: string;
        control?: undefined;
      }
    | {
        name: string;
        control: Control;
      }
  );

const Radio = ({
  name,
  required,
  control,
  id,
  defaultChecked,
  value,
  ...props
}: IRadio): JSX.Element => {
  let controller: ReturnType<typeof useController> | null = null;

  if (control) {
    controller = useController({ name, control });
  }

  return (
    <>
      <div className="radio-wrapper">
        <input
          type="radio"
          name={name}
          required={required}
          id={id}
          defaultChecked={defaultChecked}
          value={value}
          {...props}
          checked={
            controller ? controller?.field.value === value : props.checked
          }
          onChange={(e) =>
            controller ? controller?.field.onChange(value) : props.onChange?.(e)
          }
        />
        <div />
      </div>
      <style jsx>{`
        .radio-wrapper {
          position: relative;
          width: 19px;
          height: 19px;
        }

        .radio-wrapper input {
          position: absolute;
          top: 3px;
          left: 3px;
          cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
        }

        .radio-wrapper input + div {
          width: 19px;
          height: 19px;
          border-radius: 15px;
          position: relative;
          background-color: var(--white);
          content: '';
          display: inline-block;
          visibility: visible;
          border: 1px solid var(--clr-checkbox-border);
          pointer-events: none;
        }

        .radio-wrapper input:checked + div {
          border: 7px solid var(--clr-primary-1);
          transition: all 0.3s;
        }

        .radio-wrapper input:checked + div::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: white;
        }
      `}</style>
    </>
  );
};

export default Radio;
